(() => {
  function initialize(root) {
    if (root.dataset.qrbInitialized === 'true') return;
    root.dataset.qrbInitialized = 'true';
    const dialog = root.querySelector('[data-qrb-dialog]');
    const close = dialog?.querySelector('[data-qrb-dialog-close]');
    const title = dialog?.querySelector('[data-qrb-dialog-title]');
    const caption = dialog?.querySelector('[data-qrb-dialog-caption]');
    const image = dialog?.querySelector('[data-qrb-dialog-image]');
    if (!dialog || !close || !title || !caption || !image) return;
    let opener = null;
    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-qrb-preview]');
      if (!trigger || !root.contains(trigger)) return;
      const source = trigger.dataset.previewImage;
      if (!source) return;
      opener = trigger;
      image.src = source;
      image.alt = trigger.dataset.previewTitle || '';
      title.textContent = trigger.dataset.previewTitle || '';
      caption.textContent = trigger.dataset.previewCaption || '';
      if (!dialog.open) dialog.showModal();
      dialog.scrollTop = 0;
      close.focus({preventScroll: true});
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !dialog.open) return;
      const focusable = [...dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(element => !element.hidden && element.getClientRects().length);
      const first = focusable[0];
      const last = focusable.at(-1);
      if (!first) {
        event.preventDefault();
        close.focus();
      } else if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    });
    dialog.addEventListener('close', () => {
      if (opener?.isConnected) opener.focus({preventScroll: true});
      opener = null;
    });
    const stickyBar = root.querySelector('.qrb-mobile-bar');
    const purchase = root.querySelector('.qrb-native-purchase');
    const bottomCTA = root.querySelector('.qrb-bottom-cta');
    if (stickyBar && purchase && bottomCTA && 'IntersectionObserver' in window) {
      let rootVisible = false;
      let purchaseVisible = false;
      let bottomReached = false;
      const observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === root) rootVisible = entry.isIntersecting;
          else if (entry.target === purchase) purchaseVisible = entry.isIntersecting;
          else if (entry.target === bottomCTA) bottomReached = entry.isIntersecting || entry.boundingClientRect.top < 0;
        }
        stickyBar.hidden = !rootVisible || purchaseVisible || bottomReached;
      }, {threshold: 0});
      for (const element of [root, purchase, bottomCTA]) observer.observe(element);
      const stopObserving = (event) => {
        if (!event.target.contains(root)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', stopObserving);
      };
      document.addEventListener('shopify:section:unload', stopObserving);
    }
    root.addEventListener('click', (event) => {
      const anchor = event.target.closest('a[href^="#ProductInformation-"]');
      if (!anchor || !root.contains(anchor)) return;
      const purchase = document.getElementById(anchor.hash.slice(1));
      if (!purchase || !root.contains(purchase)) return;
      const nativeControl = purchase.querySelector('input[name="quantity"]:not([disabled]),button[type="submit"]:not([disabled])');
      requestAnimationFrame(() => nativeControl?.focus({preventScroll: true}));
    });
  }
  const initializeAll = (scope = document) => scope.querySelectorAll('[data-qrb-root]').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
